import { MessagingPlatform } from '@this+that/models';

export const DOBOX_CONTEXT_LIMITS = {
  MIN_KEYWORD_LENGTH: 3,
  MAX_CONTEXT_LENGTH: 10000,
  DESCRIPTION_TRUNCATE_LENGTH: 500,
  MAX_RECIPIENTS: 10,
  MAX_TO_DOMAINS: 5,
  MAX_KEYWORDS: 5,
  MAX_JSON_LENGTH: 10000,
  FALLBACK_DESCRIPTION_LENGTH: 1000,
} as const;

export const DEFAULT_TASK_GROUP_POLL_INTERVAL_MS = 2000;
export const DEFAULT_TASK_GROUP_POLL_TIMEOUT_MS = 8000;

export const CHAT_PLATFORMS = new Set<MessagingPlatform>([
  MessagingPlatform.SLACK,
  MessagingPlatform.TEAMS,
  MessagingPlatform.GOOGLE_CHAT,
]);

export const PLATFORMS_WITHOUT_EMAIL_ACTIONS: ReadonlySet<MessagingPlatform> =
  new Set([MessagingPlatform.SLACK, MessagingPlatform.GOOGLE_CHAT]);

// Read as a conversation, oldest first. The Chat tab still lists only CHAT_PLATFORMS.
export const CONVERSATION_PLATFORMS: ReadonlySet<MessagingPlatform> = new Set([
  ...CHAT_PLATFORMS,
  MessagingPlatform.WHATSAPP,
  MessagingPlatform.INSTAGRAM,
  MessagingPlatform.MESSENGER,
]);

export const EXCLUDED_WORDS = new Set([
  'with',
  'from',
  'that',
  'this',
  'have',
  'will',
  'been',
  'they',
  'them',
  'were',
  'said',
  'each',
  'which',
  'their',
  'time',
  'would',
  'there',
  'could',
  'other',
  'after',
  'first',
  'well',
  'also',
  'your',
  'way',
  'about',
  'many',
  'then',
  'these',
  'some',
  'what',
  'know',
  'take',
  'than',
  'only',
  'think',
  'come',
  'make',
  'over',
  'here',
  'into',
  'good',
  'year',
  'just',
  'work',
  'life',
  'much',
  'need',
  'back',
  'call',
  'most',
  'very',
  'more',
  'look',
  'find',
  'right',
  'might',
  'want',
  'give',
  'where',
  'show',
  'still',
  'great',
  'even',
  'such',
  'down',
  'own',
  'long',
  'little',
  'another',
  'around',
  'same',
  'different',
  'through',
  'hand',
  'last',
  'should',
  'never',
  'again',
  'part',
  'high',
  'world',
  'place',
  'large',
  'system',
  'important',
  'state',
  'small',
  'number',
  'company',
  'group',
  'business',
]);
